<template>
  <table class="worked-days-table table b-table">
    <thead>
    <template v-if="reportData.length > 0">
      <tr>
        <th scope="col" rowspan="2" v-if="!hideUser">User</th>
        <th scope="col" rowspan="2">Worked days</th>
        <th scope="col" rowspan="2">Working days in year</th>
        <template v-for="userItem in reportData[0].user_items">
          <th scope="col" :colspan="userItem.is_unlimited ? 1 : 3" :key="userItem.time_offs_name">{{ userItem.time_offs_name }}</th>
        </template>
      </tr>
      <tr>
        <template v-for="userItem in reportData[0].user_items">
          <th v-if="!userItem.is_unlimited" scope="col" :key="userItem.time_offs_settings.id + '_time_offs_name_allowed'">allowed</th>
          <th scope="col" :key="userItem.time_offs_settings.id + '_time_offs_name_used'">used</th>
          <th v-if="!userItem.is_unlimited" scope="col" :key="userItem.time_offs_settings.id + '_time_offs_name_rest'">left</th>
        </template>
        <th scope="col">Actions</th>
      </tr>
    </template>
    </thead>
    <tbody>
    <template v-for="userData in reportData">
      <tr :key="userData.user.id">
        <td scope="col" v-if="!hideUser">
          <TableUserItem :user="userData.user" :user-tooltip="false"/>
        </td>
        <td scope="col">{{ userData.worked_days }}</td>
        <td scope="col">{{ workingDaysInYear }}</td>
        <template v-for="timeOffData in userData.user_items">
          <td v-if="!timeOffData.is_unlimited" scope="col" :key="timeOffData.time_offs_settings.id + '_time_offs_allowed'">
            {{ timeOffData.time_offs_allowed }}
            <span v-if="timeOffData.time_offs_adjust > 0" style="color:green">(+{{ timeOffData.time_offs_adjust }})</span>
            <span v-else-if="timeOffData.time_offs_adjust < 0" style="color:red">({{ timeOffData.time_offs_adjust }})</span>
          </td>
          <td scope="col" :key="timeOffData.time_offs_settings.id + '_time_offs_used'">{{ timeOffData.time_offs_used }}</td>
          <td v-if="!timeOffData.is_unlimited" :key="timeOffData.time_offs_settings.id + '_time_offs_left'">{{ timeOffData.time_offs_left }}</td>
        </template>
        <td>
          <a href="javascript:void(0)"
             @click="setAdjustmentBlockData(userData.user.id, userData.user_items, 'history')">
            <font-awesome-icon icon="eye" />
          </a>
          &nbsp;
          <a href="javascript:void(0)" v-if="isCurrentYear" @click="setAdjustmentBlockData(userData.user.id, userData.user_items, 'form')">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
          </a>
          &nbsp;
          <a href="javascript:void(0)"
             @click="setAdjustmentBlockData(userData.user.id, userData.user_items, 'accrue-history')">
            <font-awesome-icon icon="clipboard-list" />
          </a>
        </td>
      </tr>
      <tr v-if="adjustmentBlockData.userId === userData.user.id && adjustmentBlockData.show" :key="userData.user.id + '_adjust_block'">
        <td scope="col" colspan="100">
          <TimeOffAdjustments
            v-if="adjustmentBlockData.userId === userData.user.id && adjustmentBlockData.show"
            v-model="adjustmentBlockData.show"
            :userId="adjustmentBlockData.userId"
            :year="year"
            :timeOffsData="adjustmentBlockData.timeOffsData"
            @dataUpdated="dataUpdated"
          />
        </td>
      </tr>
    </template>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment/moment'
import TableUserItem from '@tables/TableUserItem.vue'
import TimeOffAdjustments from '@forms/TimeOffAdjustments.vue'
export default {
  name: 'WorkedDaysReportTable',
  components: {
    TableUserItem,
    TimeOffAdjustments
  },
  props: {
    year: {
      type: Number,
      default: null
    },
    reportData: {
      type: Array,
      default () {
        return []
      }
    },
    hideUser: {
      type: Boolean,
      default: false
    },
    workingDaysInYear: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      adjustmentBlockData: {
        userId: null,
        timeOffsData: [],
        show: null
      },
      workedDaysTabIndex: 0,
      visibleItems: {}
    }
  },
  mounted () {
    this._toggleDataPageLoading(() => this.$api.timeOffsSettings.getTimeOffsSettings())
  },
  computed: {
    isCurrentYear () {
      return this.year === moment().year()
    }
  },
  methods: {
    setAdjustmentBlockData (userId, timeOffsData, show) {
      this.adjustmentBlockData = {
        userId, timeOffsData, show
      }
    },
    dataUpdated () {
      this.$emit('dataUpdated')
    }
  }
}
</script>
<style>
  .worked-days-table th, .worked-days-table td {
    text-align: center;
  }
</style>
